import type { Scene } from "@core/scene-manager";

export interface SplashSceneDeps {
  element: HTMLElement;
  cta: HTMLButtonElement;
  onEnterRequested: () => Promise<void> | void;
}

/** Заставочная сцена при запуске игры. */
export class SplashScene implements Scene {
  readonly id = "splash" as const;
  private handleClick: (() => void) | null = null;

  constructor(private readonly deps: SplashSceneDeps) {}

  /** Показывает splash-экран и навешивает обработчик на CTA. */
  onEnter(): void {
    this.deps.element.classList.add("is-visible");
    this.deps.element.setAttribute("aria-hidden", "false");
    this.handleClick = () => {
      void this.deps.onEnterRequested();
    };
    this.deps.cta.addEventListener("click", this.handleClick);
  }

  /** Скрывает splash-экран. */
  onExit(): void {
    if (this.handleClick) this.deps.cta.removeEventListener("click", this.handleClick);
    this.handleClick = null;
    this.deps.element.classList.remove("is-visible");
    this.deps.element.setAttribute("aria-hidden", "true");
  }
}
